import { useState } from 'react';
import {
  Box,
  Button,
  CardContent,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import {
  PersonOutlineOutlined,
  PlaceOutlined,
  LocalPhoneOutlined,
  EmailOutlined,
  ApartmentOutlined,
  FileUploadOutlined,
} from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useSelector } from 'react-redux';
import store, { RootState } from '../../../store/store';
import { saveSellerBuyerDetailsApi } from '../../../store/api/signup';

const SocietyDetails = ({ handleBack, handleNext }: any) => {
  const storeSignupState = useSelector((state: RootState) => state.signup);
  const storeSigninState = useSelector((state: RootState) => state.login);

  const [state] = useState([...Object.keys(storeSigninState.location)]);
  const [district, setDistrict] = useState([]);
  const [societyDetailsData, setSocietyDetailsData] = useState({
    partyGroupName: '',
    personName: '',
    address: '',
    state: '',
    city: '',
    pincode: '',
    mobileNumber: '',
    emailAddress: '',
    businessName: '',
    productType: '',
    panNumber: '',
    tinNumber: '',
    gstNumber: '',
  });

  const handleOnchange = (event: any) => {
    setSocietyDetailsData({
      ...societyDetailsData,
      [event.target.id || event.target.name]: event.target.value,
    });
  };

  const handleContinue = () => {
    const dummy = {
      mobileNumber: '9999999999',
      partyGroupName: 'ABC Society',
      address: 'Plot No 1, Bisrak Road',
      state: 'Uttar Pradesh',
      city: 'Greater Noida',
      pincode: '422001',
      emailAddress: 'ram.kumar@gmail.com',
      personName: 'Ram Kumar',
      panNumber: '',
      tinNumber: '',
      gstNumber: '',
      partyTypeId: 'PARTY_GROUP',
      partyGroupRole: 'SOCIETY',
      personRole: 'SOCIETY_ADMIN',
      password: 'demoadmin',
    };
    const reqBody: any = { ...dummy };
    store.dispatch(saveSellerBuyerDetailsApi(reqBody)).then((res) => {
      if (res.payload.status === 200) {
        handleNext();
      }
    });
  };

  return (
    <Box width={{ xs: '100%', md: '80%' }}>
      <CardContent className='signinContent' sx={{ p: 0, pt: 0.5 }}>
        <Typography variant='h5'>Society Details</Typography>
      </CardContent>

      <Box display='flex' flexDirection={'column'} gap={1} sx={{ mt: 1.5 }}>
        <TextField
          id='partyGroupName'
          placeholder='Society Name'
          size='small'
          sx={{ width: { xs: '100%', md: '32%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <ApartmentOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={societyDetailsData.partyGroupName}
          onChange={handleOnchange}
        />

        <FormControl>
          <TextField
            id='address'
            sx={{ width: { xs: '100%', md: '60%' } }}
            multiline
            rows={2}
            placeholder='Address'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <PlaceOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={societyDetailsData.address}
            onChange={handleOnchange}
          />
        </FormControl>

        <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} gap={2} sx={{ width: { xs: '100%', md: '60%' } }}>
          <FormControl fullWidth variant='outlined' size='small'>
            <InputLabel id='state'>State</InputLabel>
            <Select
              labelId='state'
              name='state'
              id='state'
              value={societyDetailsData.state}
              onChange={(event) => {
                setDistrict(storeSigninState.location[event.target.value]);
                handleOnchange(event);
              }}
              label='State'
            >
              {state &&
                state.map((el, index) => (
                  <MenuItem key={index} value={el}>
                    {el}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl fullWidth variant='outlined' size='small'>
            <InputLabel id='city'>City</InputLabel>
            <Select
              labelId='city'
              name='city'
              id='city'
              value={societyDetailsData.city}
              onChange={handleOnchange}
              label='City'
            >
              {district &&
                district.map((el: any) => <MenuItem value={el}>{el}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl sx={{ width: { xs: '100%', md: '50%' } }}>
            <TextField
              id='pincode'
              variant='outlined'
              size='small'
              placeholder='Pin Code'
              value={societyDetailsData.pincode}
              onChange={handleOnchange}
            />
          </FormControl>
        </Box>

        <TextField
          id='mobileNumber'
          placeholder='Contact Number'
          size='small'
          sx={{ width: { xs: '100%', md: '32%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <LocalPhoneOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={societyDetailsData.mobileNumber}
          onChange={handleOnchange}
        />

        <TextField
          id='emailAddress'
          placeholder='Email Address'
          size='small'
          sx={{ width: { xs: '100%', md: '32%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <EmailOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={societyDetailsData.emailAddress}
          onChange={handleOnchange}
        />

        <TextField
          id='personName'
          placeholder='Admin Name'
          size='small'
          sx={{ width: { xs: '100%', md: '32%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <PersonOutlineOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={societyDetailsData.personName}
          onChange={handleOnchange}
        />
        <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} gap={2}>
          <TextField
            id='panNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='PAN'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <FileUploadOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={societyDetailsData.panNumber}
            onChange={handleOnchange}
          />
          <TextField
            id='tinNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='TIN'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <FileUploadOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={societyDetailsData.tinNumber}
            onChange={handleOnchange}
          />
          <TextField
            id='gstNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='GST'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <FileUploadOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={societyDetailsData.gstNumber}
            onChange={handleOnchange}
          />
        </Box>

        <Box display={'flex'} gap={3} sx={{ mt: 1 }}>
          {/* <FormControl>
            <Button
              variant='outlined'
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
              disabled={storeSignupState.loading}
              onClick={handleBack}
            >
              BACK
            </Button>
          </FormControl> */}
          <FormControl>
            <LoadingButton
              loading={storeSignupState.loading}
              loadingPosition='center'
              variant='contained'
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
              onClick={handleContinue}
            >
              Update
            </LoadingButton>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default SocietyDetails;
